export const PLAN_KEYS = ["base", "standard", "full", "theatre"];
export const PLAN_LABEL = { base: "Base", standard: "Standard", full: "Full", theatre: "Theatre", custom: "Custom" };
export const PLAN_COLOR = {
  base: "bg-slate-100 text-slate-600",
  standard: "bg-emerald-100 text-emerald-700",
  full: "bg-yellow-100 text-yellow-700",
  theatre: "bg-rose-100 text-rose-700",
  custom: "bg-blue-100 text-blue-700",
};
